export default {
      id: "font-size-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#font-size-usage",
      toString: function () {
        return this.url;
      }
    }